import Http from "./http";
import History from "./history";
import { Toast,Dialog,Icon } from 'vant';
import api from '@/lib/api';
import SetDomain from '@/lib/SetDomain'

export const global = {
  Http,
  History,
  Toast,
  Dialog,
  Icon,
  api,
  SetDomain
};
